export { Textarea } from './Textarea';
export type { Props } from './Textarea.types';
